import compose from 'lodash/fp/compose'
import entries from 'lodash/fp/entries'
import isNil from 'lodash/fp/isNil'
import map from 'lodash/fp/map'
import omitBy from 'lodash/fp/omitBy'

import {BooleanUrlParam, DeepLinkSearchParams, SearchType} from './types'

export const META_PARAM_SEPARATOR = '|'

const getSearchType = (
  hotelId?: string,
  placeId?: string,
  userLocationSearch?: BooleanUrlParam
): SearchType => {
  if (hotelId) {
    return SearchType.hotelSearch
  }
  if (placeId) {
    return SearchType.placeSearch
  }
  if (userLocationSearch) {
    return SearchType.userLocationSearch
  }

  return SearchType.unknown
}

export const generateSearchParams = (searchParams?: DeepLinkSearchParams) => {
  if (!searchParams) {
    return []
  }

  const {
    checkIn,
    checkOut,
    rooms,
    hotelId,
    placeId,
    userLocationSearch,
    vclid,
    esd,
    epv,
    clickedOfferRate
  } = searchParams
  const searchType = getSearchType(hotelId, placeId, userLocationSearch)
  const customSearchParams = {
    deep_link_sub1: checkIn,
    deep_link_sub2: checkOut,
    deep_link_sub3: searchType,
    deep_link_sub4: hotelId || placeId || userLocationSearch,
    deep_link_sub5: rooms,
    deep_link_sub6:
      esd && epv
        ? `${esd}${encodeURIComponent(META_PARAM_SEPARATOR)}${epv}`
        : undefined, // combine these as they rely on each other in RAA
    deep_link_sub7: clickedOfferRate,
    deep_link_sub10: vclid
  }
  const appsFlyerParam = ([key, value]: [
    string,
    string | number | undefined
  ]) => ({
    paramKey: key,
    keys: [],
    defaultValue: [value]
  })
  const applyAppsFlyerFormat = map(appsFlyerParam)
  const removeEmptyProps = omitBy(isNil)
  const transformSearchParams = compose(
    applyAppsFlyerFormat,
    entries,
    removeEmptyProps
  )

  return transformSearchParams(customSearchParams)
}
